export class UniqueReport {
    constructor(
      public answerAVG?: number,
      public categoryTitle?: string
    ) { }

    clone() {
      return new UniqueReport(
        this.answerAVG,
        this.categoryTitle
      );
    }
  }

